import requestAction from '../../utils/requestAction'
import ComplaintInternalMessage from '../../models/ComplaintInternalMessage';

export const upsertComplaintInternalMessage = (complaintInternalMessage: (ComplaintInternalMessage), handleResponse?: (messageId: number) => void) =>
  requestAction('COMPLAINT_INTERNAL_MESSAGE_UPSERT')(
    `complaints/internal/message${(complaintInternalMessage as ComplaintInternalMessage).id ? `/${(complaintInternalMessage as ComplaintInternalMessage).id}` : ''}`,
    (complaintInternalMessage as ComplaintInternalMessage).id ? 'PUT' : 'POST',
    complaintInternalMessage,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.messageId) })
